export default __webpack_public_path__ + "img/a3389797219505c941334789d2c4dd05.svg";